import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import ApiDatabase from "server";
import Banner from "components/banner/banner";
import StyledInput from "components/styledInput/StyledInput";

const SAVE_DEBOUNCE_MS = 400;

const VISIBILITY_OPTIONS = [
    {label: 'Tous les membres', value: 'allMembers'},
    {label: 'Créateur uniquement', value: 'creatorOnly'},
];

const PermissionsContent = () => {
    const [visibilityScope, setVisibilityScope] = useState('allMembers');
    const [initialVisibilityScope, setInitialVisibilityScope] = useState('allMembers');
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        ApiDatabase.getCompanyPermissions(
            {},
            (permissions) => {
                const scope = permissions?.missions?.visibilityScope || 'allMembers';
                setVisibilityScope(scope);
                setInitialVisibilityScope(scope);
                setIsLoading(false);
            },
            (err) => {
                console.warn(err);
                setIsLoading(false);
                toast.error('Une erreur est survenue lors du chargement des permissions.');
            }
        );
    }, []);

    useEffect(() => {
        if (isLoading || visibilityScope === initialVisibilityScope) {
            return undefined;
        }

        const timeoutId = setTimeout(() => {
            setIsSaving(true);
            ApiDatabase.putCompanyPermissions(
                {missions: {visibilityScope}},
                (permissions) => {
                    const scope = permissions?.missions?.visibilityScope || visibilityScope;
                    setVisibilityScope(scope);
                    setInitialVisibilityScope(scope);
                    setIsSaving(false);
                    toast.success('Les permissions ont été mises à jour.');
                },
                (err) => {
                    console.warn(err);
                    setVisibilityScope(initialVisibilityScope);
                    setIsSaving(false);
                    toast.error('Une erreur est survenue lors de la mise à jour des permissions.');
                }
            );
        }, SAVE_DEBOUNCE_MS);

        return () => clearTimeout(timeoutId);
    }, [visibilityScope, initialVisibilityScope, isLoading]);

    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
            <div className="flex flex-col gap-8 max-w-3xl">
                <div className="flex flex-col gap-6">
                    <h2 className="text-xl font-medium text-gray-900">Permissions</h2>
                    <div className="flex flex-col gap-2">
                        <h3 className="text-base font-medium text-gray-900">Qui peut voir les missions des autres ?</h3>
                        <p className="text-sm text-gray-600">
                            Contrôle l'accès aux missions, contrats et relevés d'heures créés par un autre membre.
                        </p>
                    </div>
                    <Banner type="info" showIcon={false}>
                        Les rôles Admin, Directeur et observateurs ont toujours accès à l'ensemble des missions, quel que soit ce paramètre.
                    </Banner>
                    <div className="max-w-md">
                        <StyledInput
                            type="select"
                            label="Visibilité"
                            list={VISIBILITY_OPTIONS}
                            value={visibilityScope}
                            onChange={(event) => setVisibilityScope(event.target.value)}
                            isDisabled={isLoading || isSaving}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PermissionsContent;
